export default __webpack_public_path__ + "static/media/operation.f2247cd0.png";